// -----------------------------------------------------------------------------------------------------------------
//------------------------------------------------- For Home Page---------------------------------------------------
// -----------------------------------------------------------------------------------------------------------------

import dis_NFT_profile_pic from '../assets/images/HomePage/disNFT_profile_pic.png';
import dis_NFT_thumb from '../assets/images/HomePage/thumb_image.png';

import myProfilePhoto from '../assets/images/my_profile.png';
import postProfile01 from '../assets/images/HomePage/tom_russo.png';
import postProfile02 from '../assets/images/HomePage/paul.png';

import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';

import postImage01 from '../assets/images/HomePage/postImage01.png';
import postImage02 from '../assets/images/HomePage/postImage02.png';
import postImage03 from '../assets/images/HomePage/postImage03.png';
import postImage04 from '../assets/images/HomePage/postImage04.png';
import postImage05 from '../assets/images/HomePage/postImage05.png';
import postImage06 from '../assets/images/HomePage/postImage06.png';
import postImage07 from '../assets/images/HomePage/postImage07.png';

import p1 from '../assets/images/HomePage/p 01.png';
import p2 from '../assets/images/HomePage/p 02.png';
import p3 from '../assets/images/HomePage/p 03.png';
import p4 from '../assets/images/HomePage/p 04.png';
import p5 from '../assets/images/HomePage/p 05.png';

import slide_thumb01 from '../assets/images/HomePage/slide_thumb01.png';

import gng from '../assets/images/HomePage/gng.png';
import lowKey from '../assets/images/HomePage/low key.png';
import blackArrow from '../assets/images/HomePage/black arrow.png';
import larryPage from '../assets/images/HomePage/larry page.png';

export interface discoverNFTDataType {
    id: number;
    name: string;
    price: number;
    photo: string;
    thumImage: string;
};

export const discoverNFTData: discoverNFTDataType[] = [
    {
        id: 1,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 2,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 3,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 4,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 5,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 6,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 7,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 8,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 9,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
    {
        id: 10,
        name: "Paul George",
        price: 95745,
        photo: dis_NFT_profile_pic,
        thumImage: dis_NFT_thumb,
    },
]


// posts data
export interface postDataType {
    id: number,
    name: string,
    postProfilePhoto: string,
    minsAgo: string,
    whoCanSee: string,
    postText: string,
    isMyPost?: boolean,
    postType?: string,
    postImages?: {
        source: string,
        isVideoPlayOnPost?: boolean,
        isVideo?: boolean,
        videoSrc?: string,
        id: number,
    }[],
    profilePhoto: string,
    comments: {
        id: number,
        profLogo: string,
        commTitle?: string,
        commPhoto?: string,
        commAudio?: string,
        time: string,
    }[],
    loves: number,
    isMyloves?: boolean,
    shares: number,
}

export const postData: postDataType[] = [
    {
        id: 1,
        name: 'Tom Russo',
        postProfilePhoto: postProfile01,
        postType: 'mintnow',
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'Clean your shit up and be ready for the degeneration, all geared up for this chaotic world?',
        postImages: [{ id: 1, source: postImage01, }],
        profilePhoto: myProfilePhoto,
        loves: 2547,
        isMyloves: true,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-08 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-05 02:07:21',
            },
            {
                id: 4,
                profLogo: bid1,
                commTitle: 'Nice work bro 22222',
                time: '2022-05-04 10:07:21',
            },
            {
                id: 5,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-03 10:07:21',
            },
            {
                id: 6,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 3',
                commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                time: '2022-05-02 10:07:21',
            },
        ],
        shares: 33,
    },
    {
        id: 2,
        name: 'Paul George',
        postProfilePhoto: postProfile02,
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'Creative Art Collection',
        postImages: [{ id: 1, source: postImage02 }, { id: 2, source: postImage03 }, { id: 3, source: postImage04 }, { id: 4, source: postImage05 }, { id: 5, source: postImage06 },],
        profilePhoto: myProfilePhoto,
        loves: 27,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-02 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-03 10:07:21',
            },
        ],
        shares: 10,
    },
    {
        id: 3,
        name: 'Tom Russo',
        postProfilePhoto: postProfile01,
        postType: 'mintnow',
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'Your token for exclusive access and discounts on the Americana Marketplace.',
        postImages: [{ id: 1, source: postImage07 },],
        profilePhoto: myProfilePhoto,
        loves: 287,
        isMyloves: true,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-04 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-02 10:07:21',
            },
        ],
        shares: 30,
    },
    {
        id: 4,
        name: 'Tom Russo',
        postProfilePhoto: postProfile01,
        postType: 'mintnow',
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'Not having fun at all',
        postImages: [{ id: 1, source: postImage01 },],
        profilePhoto: myProfilePhoto,
        loves: 247,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-01 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-02 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-05 10:07:21',
            },
        ],
        shares: 33,
    },
    {
        id: 5,
        name: 'Paul George',
        postProfilePhoto: postProfile02,
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'From one of the founders of Zynga and some of the creative minds behind FarmVille and Words With Friends comes Town Star. Blockchain is the next evolution of gaming and has the $148B industry buzzing with excitement. It’s gaming re-imagined to benefit creators and players, alike.',
        postImages: [{ id: 1, source: postImage04 }, { id: 2, source: postImage05 }, { id: 3, source: postImage06 },],
        profilePhoto: myProfilePhoto,
        loves: 240,
        isMyloves: true,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-05 09:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-04 10:07:21',
            },
            {
                id: 4,
                profLogo: bid1,
                commTitle: 'Nice work bro 2',
                time: '2022-05-03 10:07:21',
            },
            {
                id: 5,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams 2222',
                time: '2022-05-02 10:07:21',
            },
            {
                id: 6,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 3',
                time: '2022-05-01 10:07:21',
            },
        ],
        shares: 33,
    },
    {
        id: 6,
        name: 'Tom Russo',
        postProfilePhoto: postProfile01,
        postType: 'mintnow',
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'This is an image of a Lucky Cat. The left paw beckons people and the right paw beckons money. This time, the cat is holding up the left paw to wave people in. Apparently, to gather people means to summon good luck. Please stay tuned to find out what kind of story will develop from the coin bank in the shape of a Lucky Cat.',
        postImages: [{ id: 1, source: postImage07 },],
        profilePhoto: myProfilePhoto,
        loves: 150,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-03 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-02 10:07:21',
            },
        ],
        shares: 3,
    },
    {
        id: 7,
        name: 'Paul George',
        postProfilePhoto: postProfile02,
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'A community celebrating representation, inclusivity, and equal opportunities for all. United by a first-of-its-kind collection, featuring 10,000 artworks of diverse and powerful women.',
        postImages: [{ id: 1, source: postImage04 }, { id: 2, source: postImage05 },],
        profilePhoto: myProfilePhoto,
        loves: 240,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-03 10:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-04 10:07:21',
            },
        ],
        shares: 33,
    },
    {
        id: 8,
        name: 'Paul George',
        postProfilePhoto: postProfile02,
        minsAgo: '2022-05-08 10:07:21',
        whoCanSee: 'friends',
        postText: 'Thousands of Sheep and Wolves compete on a farm in the metaverse. A tempting prize of WOOL awaits, with deadly high stakes. All the metadata and images are generated and stored 100% on-chain. No IPFS. NO API. Just the Ethereum blockchain. View the other official collections:',
        postImages: [{ id: 1, source: postImage02 }, { id: 2, source: postImage03 }, { id: 3, source: postImage04 }, { id: 4, source: postImage05 }, { id: 5, source: postImage06 }, { id: 6, source: postImage02 }, { id: 7, source: postImage03 }, { id: 8, source: postImage04 },],
        profilePhoto: myProfilePhoto,
        loves: 240,
        comments: [
            {
                id: 1,
                profLogo: bid1,
                commTitle: 'Nice work bro',
                time: '2022-05-05 10:07:21',
            },
            {
                id: 2,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams',
                time: '2022-05-05 08:07:21',
            },
            {
                id: 3,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 2222222',
                time: '2022-05-04 10:07:21',
            },
            {
                id: 4,
                profLogo: bid1,
                commTitle: 'Nice work bro 2',
                time: '2022-05-03 10:07:21',
            },
            {
                id: 5,
                profLogo: bid2,
                commTitle: 'Liked  by Autistic dreams 2',
                time: '2022-05-02 10:07:21',
            },
            {
                id: 6,
                profLogo: bid3,
                commTitle: 'Liked  by Autistic dreams 3',
                time: '2022-05-01 10:07:21',
            },
        ],
        shares: 33,
    },
]







export interface followItemsType {
    id: number,
    logo: string,
    name: string,
    verified: boolean,
    designation: string,
    follow: boolean,
}

export const followItemsData: followItemsType[] = [
    {
        id: 1,
        logo: gng,
        verified: true,
        name: 'Gen.G',
        designation: 'Team',
        follow: true,
    },
    {
        id: 2,
        logo: lowKey,
        verified: true,
        name: 'Low Key',
        designation: 'Team',
        follow: true,
    },
    {
        id: 3,
        logo: blackArrow,
        verified: false,
        name: 'Black Arrows',
        designation: 'Sponsor',
        follow: false,
    },
    {
        id: 4,
        logo: larryPage,
        verified: false,
        name: 'Larry Page',
        designation: 'Team Manager',
        follow: false,
    },
]









// -----------------------------------------------------------------------------------------------------------------
//------------------------------------------------- For Profile Page------------------------------------------------
// -----------------------------------------------------------------------------------------------------------------


export interface profileRecentBidsDataType {
    id: number,
    photo: string,
    name: string,
    price: string,
}

export const profileRecentBidsData: profileRecentBidsDataType[] = [
    {
        id: 1,
        photo: dis_NFT_profile_pic,
        name: 'Paul George',
        price: '95,745',
    },
    {
        id: 2,
        photo: lowKey,
        name: 'Paul George',
        price: '95,745',
    },
    {
        id: 3,
        photo: blackArrow,
        name: 'Paul George',
        price: '95,745',
    },
    {
        id: 4,
        photo: larryPage,
        name: 'Paul George',
        price: '95,745',
    },

]



